import React, { useEffect, useState } from "react";
import { ActiveJobsTable } from "../dashboard/ActiveJobsTable";
import { JobCardDetailsDialog } from "../jobCards/JobCardDetailsDialog";
import { getActiveJobs } from "../generic/crud";
import { PageTitle } from "../../../_metronic/layout/core";

export const ActiveJobsPage = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshCounter, setRefreshCounter] = useState(0);

  // Dialog state
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailsJobCardId, setDetailsJobCardId] = useState(null);

  useEffect(() => {
    fetchData();
  }, [refreshCounter]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getActiveJobs();
      setJobs(response.data || []);
    } catch (error) {
      console.error("Error fetching active jobs:", error);
      setJobs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleJobClick = (job) => {
    setDetailsJobCardId(job.id);
    setShowDetailsModal(true);
  };

  const handleRefresh = () => {
    setRefreshCounter((prev) => prev + 1);
  };

  return (
    <>
      <PageTitle>Active Jobs</PageTitle>
      <ActiveJobsTable
        jobs={jobs}
        loading={loading}
        onJobClick={handleJobClick}
      />
      <JobCardDetailsDialog
        show={showDetailsModal}
        handleClose={() => setShowDetailsModal(false)}
        jobCardId={detailsJobCardId}
        onStatusChange={handleRefresh}
      />
    </>
  );
};
